import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'

const MainLayout: React.FC = () => {
    return (
        <div className="main-layout">
            <a href="#main-content" className="skip-link">Skip to main content</a>
            <Navbar />
            <main id="main-content" tabIndex={-1}>
                <Outlet />
            </main>
            <Footer />
        </div>
    )
}

export default MainLayout
